import { getters } from "@/constants/state";

export default {
  [getters.AVAILABILITY_REMINDER_EMPLOYEES_GETTER]: (state) => state.employees,
};
